import { Info } from "lucide-react";

export default function ArticleBlocks({ blocks = [] }) {
  return (
    <div className="space-y-5">
      {blocks.map((b, i) => {
        if (typeof b === "string") {
          return (
            <p key={i} className="text-lg leading-relaxed text-navy/75">
              {b}
            </p>
          );
        }
        if (b.p) {
          return (
            <p key={i} className="text-lg leading-relaxed text-navy/75">
              {b.p}
            </p>
          );
        }
        if (b.h3) {
          return (
            <h3 key={i} className="pt-2 font-heading text-xl font-medium text-navy md:text-2xl">
              {b.h3}
            </h3>
          );
        }
        if (b.ul) {
          return (
            <ul key={i} className="space-y-3">
              {b.ul.map((li, j) => (
                <li key={j} className="flex items-start gap-3 text-lg leading-relaxed text-navy/75">
                  <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-electric" />
                  <span>{li}</span>
                </li>
              ))}
            </ul>
          );
        }
        if (b.ol) {
          return (
            <ol key={i} className="space-y-3">
              {b.ol.map((li, j) => (
                <li key={j} className="flex items-start gap-4 text-lg leading-relaxed text-navy/75">
                  <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-electric font-mono text-xs text-electric">
                    {j + 1}
                  </span>
                  <span>{li}</span>
                </li>
              ))}
            </ol>
          );
        }
        if (b.note) {
          return (
            <div
              key={i}
              className="flex items-start gap-3 border-l-2 border-electric bg-ice p-5 text-navy/80"
            >
              <Info className="mt-0.5 h-5 w-5 shrink-0 text-electric" />
              <p className="leading-relaxed">{b.note}</p>
            </div>
          );
        }
        return null;
      })}
    </div>
  );
}
